import request from '@/utils/request'

// 获取baseURL，完全依赖环境变量
const getBaseURL = () => {
  if (!process.env.VUE_APP_BASE_API) {
    throw new Error('VUE_APP_BASE_API 环境变量未设置，请检查环境配置')
  }
  return process.env.VUE_APP_BASE_API
}

export function login(data) {
  // 直接使用window.fetch，绝对能在Network中看到
  const body = `captcha=${encodeURIComponent(data.captcha)}&username=${encodeURIComponent(data.username)}&password=${encodeURIComponent(data.password)}&uuid=${encodeURIComponent(data.uuid)}`;
  
  console.log('登录请求参数:', body);
  
  return window.fetch(`${getBaseURL()}/_user/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: body
  }).then(res => {
    console.log('登录响应状态:', res.status);
    return res.json();
  }).then(data => {
    console.log('登录响应数据:', data);
    return data;
  });
}

export function getInfo(token) {
  // 直接使用原生fetch，确保Network中能看到
  // token通过Request Headers传递，格式：DU [token]
  return window.fetch(`${getBaseURL()}/_user/info`, {
    method: 'GET',
    headers: {
      'Token': `DU ${token}`
    }
  }).then(res => res.json());
}

export function getHomeAccess() {
  return request.get('/_user/homeAccess')
}

export function updateProfile(data) {
  return request.put('/_user/profile', data)
}

export function logout() {
  return request({
    url: '/_user/logout',
    method: 'post'
  })
}
export  function UploadFile(data) {
  return request({
    url: '/sys/cosUploader/upload',
    method: 'post',
    data
  })
}
